import React from 'react';
import Translate from 'components/Translate';
import styles from './Privacy.module.css';
import UsersPrivacySettings from '../../backbone/models/user/UsersPrivacySettings';
import { getActivitySubcategoryInOrder } from '../../utils/ActivityTypesUtil';
import i18next from 'config/i18next';
import { withTranslation } from 'react-i18next';

class CustomPrivacyLevelsOptions extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            changedOptions: [],
            activitySubcategoryPrivacyLocalSettings: [...props.activitySubcategoryPrivacySettings]
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (
            JSON.stringify(this.props.activitySubcategoryPrivacySettings) !==
            JSON.stringify(prevProps.activitySubcategoryPrivacySettings)
        ) {
            this.setState({
                activitySubcategoryPrivacyLocalSettings: [...this.props.activitySubcategoryPrivacySettings]
            });
        }
    }

    changeOptionValue = (e, field) => {
        const { activitySubcategoryPrivacyLocalSettings } = this.state;
        const { changeOptionValue, activitySubcategoryPrivacySettings } = this.props;
        let changes = [...this.state.changedOptions];
        let changedField = {};
        let foundItem = changes.find((item) => Object.keys(item)[0] === field);

        if (foundItem) {
            //if value was alreadyAdded
            foundItem[field] = e.target.value;
        } else {
            changedField[field] = e.target.value;
            changes.push(changedField);
        }

        let newActivitySubcategoryPrivacySettings = activitySubcategoryPrivacyLocalSettings.map((subcategory) => {
            let returnObj = {
                ...subcategory,
                subcategoryDetails: {
                    ...subcategory.subcategoryDetails
                }
            };

            if (subcategory.privacySubcategoryType === field) {
                if (changedField[field]) {
                    returnObj.subcategoryDetails.accessRule = changedField[field];
                } else if (foundItem[field]) {
                    returnObj.subcategoryDetails.accessRule = foundItem[field];
                }
            }

            return returnObj;
        });

        this.setState({
            changedOptions: [...changes],
            activitySubcategoryPrivacyLocalSettings: newActivitySubcategoryPrivacySettings
        });

        if (typeof changeOptionValue === 'function') {
            changeOptionValue([...changes], newActivitySubcategoryPrivacySettings);
        }
    };

    getMainContent = () => {
        const { activitySubcategoryPrivacyLocalSettings } = this.state;
        let activitySubcategoriesInOrder = getActivitySubcategoryInOrder(activitySubcategoryPrivacyLocalSettings);

        return activitySubcategoriesInOrder.map((option) => {
            return (
                <div key={option.privacySubcategoryType} className={styles.optionContainer}>
                    <div className={styles.optionTitleContainer}>
                        <Translate ns="activity_types" content={`activity_type_${option.privacySubcategoryType}`} />
                    </div>
                    <div className={styles.dropdownContainer}>
                        <select
                            className={styles.selectInput}
                            onChange={(e) => {
                                this.changeOptionValue(e, option.privacySubcategoryType);
                            }}
                            value={option.subcategoryDetails.accessRule}
                        >
                            <option value={UsersPrivacySettings.Visibility.PRIVATE}>
                                {i18next.t('privacy_alert:privacy.alert.only.me')}
                            </option>
                            <option value={UsersPrivacySettings.Visibility.SUBSCRIBERS}>
                                {i18next.t('privacy_alert:privacy.alert.connections')}
                            </option>
                            <option value={UsersPrivacySettings.Visibility.GROUPS}>
                                {i18next.t('privacy_alert:privacy.alert.groups')}
                            </option>
                            <option value={UsersPrivacySettings.Visibility.PUBLIC}>
                                {i18next.t('privacy_alert:privacy.alert.everyone')}
                            </option>
                        </select>
                    </div>
                </div>
            );
        });
    };

    render() {
        const { activitySubcategoryPrivacyLocalSettings } = this.state;

        return (
            <>
                <p>
                    <Translate ns="settings" content="privacy_custom_levels_description" />
                </p>
                {activitySubcategoryPrivacyLocalSettings && activitySubcategoryPrivacyLocalSettings.length
                    ? this.getMainContent()
                    : null}
            </>
        );
    }
}
export default withTranslation(['privacy_alert'])(CustomPrivacyLevelsOptions);
